/**
 * Cortex Policies admin page (GDN-1816).
 *
 * Lists global policies, allows creating new drafts, editing existing
 * drafts, and lifecycle transitions. The list/dialog machinery lives in
 * CortexPoliciesPanel, shared with the org detail page's Policies section
 * (GDN-2407) which renders the same panel at organization scope.
 */

import { Box, Typography } from '@mui/material';

import { AppHeader } from '../components/app-header';
import { BackButton } from '../components/back-button';
import { CortexPoliciesPanel } from '../components/cortex-policies-panel';

export default function CortexPoliciesPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <AppHeader />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-4">
          <BackButton fallbackUrl="/admin-v2" />
        </div>

        <Box sx={{ mb: 3 }}>
          <h1 className="text-2xl font-bold text-gray-900">Cortex Policies</h1>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Global citation-grounded policies. Draft policies are editable;
            active and deprecated rows are read-only.
          </Typography>
        </Box>

        <CortexPoliciesPanel scope="global" />
      </main>
    </div>
  );
}
